import { Attributes, Children, Component } from 'react';
import styles from './sortable.component.module.scss';


interface SortableItemComponentProps extends Attributes {
    onTouchStart: (e) => void;
    onMouseDown: (e) => void;
    children?: any;
    index: number;
    uniquekey: string;
}

export default class SortableItemComponent extends Component<SortableItemComponentProps> {

    shouldComponentUpdate() {
        return true;
    }

    render() {
        // console.log(`Image at ${this.props.index} ${this.props.uniquekey} is ${this.props.children.props.children.props.uploadInProgressFile.file.name}`);
        return (
            <div
                key={`${this.props.uniquekey}`}
                className={`b${this.props.index} sortable-item ${styles["sortable-item"]} col-12  mb-2`}
                onMouseDown={e => this.props.onMouseDown(e)}
                onTouchStart={e => this.props.onTouchStart(e)}
            >
                {this.props.children}
            </div>
        );
    }
}
